module.exports = __webpack_public_path__ + "static/man-blond-0d7ad12dba388bae0bb9a8c020ea3b3d.jpg";